import { useAuth } from '@/contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import ApiTokensSection from '@/components/admin/ApiTokensSection';
import { PageSkeleton } from '@/components/ui/page-skeleton';

export default function Tokens() {
  const { user, loading } = useAuth();

  if (loading) return <PageSkeleton />;

  const roles = user?.roles ?? [];
  if (!roles.includes('especial')) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="container py-6 space-y-6">
      <ApiTokensSection />
    </div>
  );
}
